import React from 'react';

import JourneyBuilderSendOptimizerContainer from './SendOptimizer/JourneyBuilderSendOptimizerContainer';

const JourneyBuilderArea = () => <JourneyBuilderSendOptimizerContainer />;

JourneyBuilderArea.displayName = 'JourneyBuilderArea';

export default JourneyBuilderArea;



// WEBPACK FOOTER //
// ./src/JourneyBuilder/index.js